import classes from "./iconSecondary.module.scss";
import SecondaryButton, { SecondaryButtonProps } from "./SecondaryButton";
import React from "react";

type IconSecondaryButtonProps = {
  url?: string;
} & SecondaryButtonProps

export const IconSecondaryButton = (props: IconSecondaryButtonProps) => {
  const { url, ...secondaryButtonProps } = props;

  secondaryButtonProps.className = classes.iconButton;

  return (
    <SecondaryButton {...secondaryButtonProps}>
      { url && <img src={url} width={12} alt=""/> }
    </SecondaryButton>
  );
};
